import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../services/localstorage.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
  	private _localStorageService: LocalStorageService,
  	private _router: Router,
    ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
  	let authenticated = !!this._localStorageService.get('token');
  	if (authenticated) { 
      return true; 
    }
    window.location.href = environment.zeebraUrl;
    return false;
  }
}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/guards/auth.guard.ts